import axios from 'axios';

axios.defaults.timeout = 60000

axios.defaults.withCredentials = true;
// 创建axios实例

axios.create({

    withCredentials: false,
    timeout: 300000 // 请求超时时间
});

// request拦截器
axios.interceptors.request.use(config => {

    // 在请求发送前做处理
    // if (localStorage.token) {
    //     config.headers['Authorization'] = localStorage.token; // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改

    // }

    return config;
}, error => {
    //请求失败后的操作
    Promise.reject(error);
})

// respone拦截器
axios.interceptors.response.use(

    response => {

        const res = response
        if (response.status === 401 || res.status === 40101) {
            
            return Promise.reject('error');
        }
        if (res.status === 40301) {
            
            return Promise.reject('error');
        }
        if (response.status !== 200 && res.status !== 200) {
            
        } else {
            return response
        }
    },
    error => {

        // Message({
        //     message: error.message,
        //     type: 'error',
        //     duration: 5 * 1000
        // });
        return Promise.reject(error);
    }
);

//get请求封装
export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {

                params: params
            })
            .then(response => {
                resolve(response);
            })
            .catch(err => {
                reject(err)
            })
    })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data) {
    return new Promise((resolve, reject) => {
        axios.post(url,data)

        .then(response => {
            resolve(response);
        }, err => {
            reject(err)
        })
    })
}



// WEBPACK FOOTER //
// ./src/api/index.js